import React from 'react'
import PropTypes from 'prop-types'
import { browserHistory, Router } from 'react-router'
import { Provider } from 'react-redux'
import Bootstrap from 'bootstrap/dist/css/bootstrap.css' //eslint-disable-line
import FontAwesome from 'font-awesome/css/font-awesome.css' //eslint-disable-line

function AppContainer({ routes, store }) {
  return (
    <Provider store={store}>
      <div style={{ height: '100%' }}>
        <Router history={browserHistory} children={routes} />
      </div>
    </Provider>
  )
}

AppContainer.propTypes = {
  routes: PropTypes.object.isRequired,
  store: PropTypes.object.isRequired
}

export default AppContainer



// WEBPACK FOOTER //
// ./src/containers/AppContainer.js